import React, { useState, useEffect } from 'react';
import {FaArrowUp} from 'react-icons/fa';

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  // Show button after scrolling down 300px
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="scroll-to-top-btn"
      style={{
        position: 'fixed',
        bottom: '40px',
        right: '30px',
        zIndex: 999,
        backgroundColor: '#FF0072',
        color: '#fff',
        border: 'none',
        borderRadius: '50%',
        padding: '12px 15px',
        cursor: 'pointer',
        boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
      }}
    >
      <FaArrowUp size={20} />
    </button>
  );
};

export default ScrollToTopButton;
